/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ beforeText: NonNullable<unknown>, afterText: NonNullable<unknown> }} Workout_After_Carry_LoadInputs */

const en_us2_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weight: ${i?.beforeText} → ${i?.afterText}`)
};

const pt_br2_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga: ${i?.beforeText} → ${i?.afterText}`)
};

const es_419_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso: ${i?.beforeText} → ${i?.afterText}`)
};

const pt_pt2_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga: ${i?.beforeText} → ${i?.afterText}`)
};

const fr_fr2_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Charge : ${i?.beforeText} → ${i?.afterText}`)
};

const de_de2_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewicht: ${i?.beforeText} → ${i?.afterText}`)
};

const it_it2_workout_after_carry_load = /** @type {(inputs: Workout_After_Carry_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carico: ${i?.beforeText} → ${i?.afterText}`)
};

/**
* | output |
* | --- |
* | "Weight: {beforeText} → {afterText}" |
*
* @param {Workout_After_Carry_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_load = /** @type {((inputs: Workout_After_Carry_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_load(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_load(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_load(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_load(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_load(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_load(inputs)
	return en_us2_workout_after_carry_load(inputs)
});
export { workout_after_carry_load as "workout-after.carry_load" }